<template>
  <div class="block">
    <div class="block__header">
      <h2 class="block__title">{{searchResults.IntroTitle}}</h2>
      <ul class="introduction-nav">
        <!-- <li class="introduction-nav__item" v-for="item in content.nav">
          <a href="#">{{item.title}}</a>
        </li> -->
      </ul>
    </div>
    <div class="block__content">
      <div class="introduction">
        {{{searchResults.IntroParagraph}}}
        <ul v-if="searchResults.IntroBullets">
          <li v-for="bullet in searchResults.IntroBullets">{{bullet}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  vuex: {
    getters: {
      searchResults: state => state.searchResults
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .introduction{
    color: $white;
    padding-bottom: 40px;
    line-height: 1.5em;

    ul{
      margin: 0;
      padding: 0;
      list-style-type: none;

      li{
        margin: 20px 0 0;
        &:before{
          content: "- "
        }
      }
    }
  }

  .introduction-nav{
    padding: 0;
    margin: 18px 0 0;
    list-style: none;
    line-height: 1em;

    &__item{
      display: inline;
      margin-right: 30px;

      a{
        color: $green_dark;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// SearchIntro.vue?6ca4832a